import React from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";

export function ShipmentDetailsStep() {
  const { register, watch } = useFormContext();
  const access247 = watch("access247");

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Flower & Non-Floral Shipment Details
        </h3>

        <div className="space-y-2">
          <Label htmlFor="deliveryAddress">Complete Delivery Address</Label>
          <Input id="deliveryAddress" {...register("deliveryAddress")} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <Label htmlFor="emergencyContactName">Emergency Contact Name</Label>
            <Input
              id="emergencyContactName"
              {...register("emergencyContactName")}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="emergencyContactPhone">Phone #</Label>
            <Input
              id="emergencyContactPhone"
              type="tel"
              {...register("emergencyContactPhone")}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="emergencyContactEmail">Email</Label>
            <Input
              id="emergencyContactEmail"
              type="email"
              {...register("emergencyContactEmail")}
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="receivingHours">
            Receiving Hours (if known and not 24/7 access)
          </Label>
          <Input id="receivingHours" {...register("receivingHours")} />
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">Delivery Details</h3>

        <div className="space-y-4">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">
              Can we access the building 24/7 via lockbox or keypad?
            </Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("access247")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("access247")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          {access247 === "No" && (
            <div className="space-y-2 pl-4 border-l-2 border-slate-200">
              <Label htmlFor="entryInstructions">Specific entry instructions or contact info</Label>
              <Input id="entryInstructions" {...register("entryInstructions")} required />
            </div>
          )}

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">
              Does the building have an active alarm system that we need to disarm?
            </Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("activeAlarm")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("activeAlarm")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">
              Do you need us to provide a lockbox for your site?
            </Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("needLockbox")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("needLockbox")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">
              Does the delivery environment allow for 53' truck/trailer access without obstructions?
            </Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("truckAccess53")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("truckAccess53")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">Is your dock sealed?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("dockSealed")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("dockSealed")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">Is the delivery door taller than 8 feet?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("doorTallerThan8ft")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("doorTallerThan8ft")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="unloadingEquipment">
              Do you provide on-site unloading equipment (Pallet jack, Forklift, or Carts)?
            </Label>
            <Input id="unloadingEquipment" {...register("unloadingEquipment")} placeholder="e.g., Pallet jack, Forklift, None" />
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">Is the path to the cooler(s) level and wide enough for a full pallet?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("pathLevelAndWide")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("pathLevelAndWide")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <Label className="text-base">Are there multiple coolers or complex drop-off points?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("multipleCoolers")}
                  className="h-4 w-4"
                />
                <span>Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("multipleCoolers")}
                  className="h-4 w-4"
                />
                <span>No</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">Freight Details</h3>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="ltlProduct">LTL Product/Commodity</Label>
            <Input id="ltlProduct" {...register("ltlProduct")} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="ltlTemperature">
              LTL Freight Temperature Required
            </Label>
            <Input id="ltlTemperature" {...register("ltlTemperature")} />
          </div>

          <div className="space-y-2">
            <Label>LTL Freight originating from:</Label>
            <div className="flex flex-wrap gap-4">
              {["Florida", "California", "Florida & California"].map(
                (origin) => (
                  <label key={origin} className="flex items-center space-x-2">
                    <input
                      type="radio"
                      value={origin}
                      {...register("freightOrigin")}
                      className="h-4 w-4"
                    />
                    <span className="text-sm">{origin}</span>
                  </label>
                ),
              )}
            </div>
          </div>

          <div className="space-y-2">
            <Label>
              Will freight be delivered to an Armellini Terminal or is pick up
              required?
            </Label>
            <div className="flex flex-wrap gap-4">
              {["Dropped at Terminal", "Pickup"].map((option) => (
                <label key={option} className="flex items-center space-x-2">
                  <input
                    type="radio"
                    value={option}
                    {...register("terminalOrPickup")}
                    className="h-4 w-4"
                  />
                  <span className="text-sm">{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="pickupAddress">Pick up Address</Label>
            <Input id="pickupAddress" {...register("pickupAddress")} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="currentCarrier">Current Carrier Name</Label>
            <Input id="currentCarrier" {...register("currentCarrier")} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="ltlVolume">
              LTL Volume per shipment (please specify number of boxes/cubes or
              pallets)
            </Label>
            <Input id="ltlVolume" {...register("ltlVolume")} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="routineShipment">Is this a routine shipment?</Label>
            <Input id="routineShipment" {...register("routineShipment")} />
          </div>
        </div>
      </div>
    </div>
  );
}
